var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock"},[_c('div',{staticClass:"header-text-clock"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.clockDate))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.clockTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }